import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env';
import {DateRange, EventDropdowns, EventInterface, GameList, UserById, Success} from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class CalendarApiService {

  constructor(
    private http: HttpClient,
  ) {
  }

  public getEvents(range: DateRange): Observable<EventInterface[]> {
    return this.http.post<EventInterface[]>(`${environment.apiUrl}events/range`, range);
  }

  public getEventById(event_id: string): Observable<EventInterface> {
    return this.http.get<EventInterface>(`${environment.apiUrl}events/${event_id}`)
  } 

  public getEventDropdowns(): Observable<EventDropdowns> {
    return this.http.get<EventDropdowns>(`${environment.apiUrl}events/creation-dropdowns`);
  }

  public getWarfareGamesList(): Observable<GameList[]> {
    return this.http.post<GameList[]>(`${environment.apiUrl}events/warfare-game`, {});
  }

  public getHostsByName(query: string): Observable<UserById[]> {
    return this.http.post<UserById[]>(`${environment.apiUrl}events/search?query=${query}`, {query});
  }

  public saveEvent(data: FormData, id: string = ''): Observable<{ event: EventInterface, msg: string }> {
    if (id) {
      return this.http.patch<{ event: EventInterface, msg: string }>(`${environment.apiUrl}events/${id}`, data);
    }
    return this.http.post<{ event: EventInterface, msg: string }>(`${environment.apiUrl}events`, data);
  }

  public deleteEvent(id: string, deleteRecurrings?: boolean): Observable<Success> {
    return this.http.request<Success>(
      'delete',
      `${environment.apiUrl}events/${id}`,
      {
        body: {delete_recurrings: deleteRecurrings}
      });
  }

  public changeTutorialStatus(status: { schedule_tutorial: boolean }): Observable<Success> {
    return this.http.patch<Success>(`${environment.apiUrl}users/tutorial`, status);
  }

  public getTutorialStatus(): Observable<{ schedule_tutorial: boolean }> {
    return this.http.get<{ schedule_tutorial: boolean }>(`${environment.apiUrl}users/tutorial`);
  }

  public getGamesListByType(game_format: number, category_name: string): Observable<GameList[]> {
    return this.http.post<GameList[]>(`${environment.apiUrl}events/all-games`, {game_format, category_name});
  }

}
